import React, { FC, useState } from "react";
import ExperienceData from "./Tabs/ExperienceData";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Wrapper } from "../styled";

const experienceTabs = [
  {
    title: "Стаж",
    component: <ExperienceData/>,
  },
];


const Experience: FC = () => {
  const [tab, setTab] = useState(0);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Wrapper>
      <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        {experienceTabs.map((tab) => (
          <Tab key={tab.title} label={tab.title} />
        ))}
      </Tabs>
      {experienceTabs[tab].component}
    </Wrapper>
  );
};

export default Experience;